import { CLEAR_ITEM_CATEGORIES_DATA, ITEM_CATEGORIES_DATA } from '../actions/actionType'

const initialState = {
  itemCategories: [],
}
export default function ItemCategoriesReducer(state = initialState, action) {
  switch (action.type) {
    case ITEM_CATEGORIES_DATA:
      return { ...state, itemCategories: action.payload }
    case CLEAR_ITEM_CATEGORIES_DATA:
      return { ...state, itemCategories: [] }
    default:
      return state
  }
}
